import { useState } from "react";

import { appApi } from "../../core/api/app.js";
import { tagTone } from "../../core/format/tags.js";
import { addDays, dayLabelFull, upTo, weekLabel, weekRange, weekStart } from "../../core/format/periods.js";
import { useAppSession } from "../../state/AppSessionContext.jsx";
import { useEndpoint } from "../../state/useEndpoint.js";
import { Empty, Failed, Loading, Panel } from "../components/Panel.jsx";
import PeriodNav from "../components/PeriodNav.jsx";

export default function Work() {
  const { token, me } = useAppSession();
  const today = me?.today ?? new Date().toISOString().slice(0, 10);
  const currentWeek = weekStart(today);
  const [start, setStart] = useState(currentWeek);

  const { from, to } = weekRange(start);
  const { data, loading, error } = useEndpoint(() => appApi.tasks(token, from, to), [token, from, to]);

  const byDate = new Map((data?.days ?? []).map((d) => [d.date, d]));
  const week = upTo(Array.from({ length: 7 }, (_, i) => addDays(start, i)), today);

  const all = (data?.days ?? []).flatMap((d) => d.tasks);
  const unplanned = all.filter((t) => !t.planned).length;

  return (
    <>
      <PeriodNav
        label={weekLabel(start)}
        onPrev={() => setStart(addDays(start, -7))}
        onNext={() => setStart(addDays(start, 7))}
        atLatest={start >= currentWeek}
        right={data ? `${all.length} tasks · ${unplanned} unplanned` : null}
      />

      {loading && <Loading />}
      {error && <Failed error={error} />}

      {data && !loading && (
        <>
          {week.map((date) => {
            const day = byDate.get(date);
            return (
              <Panel
                key={date}
                title={dayLabelFull(date, today)}
                meta={day ? `${day.tasks.length} logged` : date}
              >
                {!day ? (
                  <Empty>No wrap-up happened that night.</Empty>
                ) : day.tasks.length === 0 ? (
                  <Empty>Wrap-up ran, nothing was logged.</Empty>
                ) : (
                  <ul className="tasklist">
                    {day.tasks.map((task, i) => (
                      <li key={i}>
                        <span className="tasklist-title">{task.title}</span>
                        {task.category && <span className={`pill tone-${tagTone(task.category)}`}>{task.category}</span>}
                        {task.actualFrom && (
                          <span className="tasklist-due mono">
                            {task.actualFrom}–{task.actualTo ?? "?"}
                          </span>
                        )}
                      </li>
                    ))}
                  </ul>
                )}
              </Panel>
            );
          })}
        </>
      )}
    </>
  );
}
